import React, { useState } from 'react';
import { Camera, Star, Music, Users } from 'lucide-react';
import '../styles/components/Home.css';

const Home = ({ posts, sampleUsers, inspirationalMessages, addToInterests, setActiveTab }) => {
   const [searchQuery, setSearchQuery] = useState('');
   const [showSearch, setShowSearch] = useState(false);
   const [currentMessage] = useState(inspirationalMessages[Math.floor(Math.random() * inspirationalMessages.length)]);

   const filteredUsers = sampleUsers.filter(user =>
      user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.username.toLowerCase().includes(searchQuery.toLowerCase())
   );

   if (showSearch) {
      return (
         <div className="home-search-container">
            <div className="search-header">
               <div className="search-nav">
                  <button
                     onClick={() => setShowSearch(false)}
                     className="back-button"
                  >
                     ←
                  </button>
                  <h2 className="search-title">Search Friends</h2>
               </div>
               <div className="search-input-container">
                  <input
                     type="text"
                     placeholder="Search users..."
                     value={searchQuery}
                     onChange={(e) => setSearchQuery(e.target.value)}
                     className="search-input"
                     autoFocus
                  />
               </div>
            </div>

            <div className="search-results">
               {searchQuery === '' ? (
                  <div className="search-sections">
                     <div className="search-section">
                        <h3 className="section-title">Suggested for you</h3>
                        <div className="user-list">
                           {sampleUsers.filter(user => !user.following).slice(0, 4).map((user, idx) => (
                              <div key={idx} className="user-card">
                                 <div className="user-info">
                                    <div className="user-avatar"></div>
                                    <div className="user-details">
                                       <p className="user-name">{user.name}</p>
                                       <p className="user-meta">{user.username} • {user.followers} followers</p>
                                    </div>
                                 </div>
                                 <button className="follow-button">Follow</button>
                              </div>
                           ))}
                        </div>
                     </div>

                     <div className="search-section">
                        <h3 className="section-title">Popular on ILYO</h3>
                        <div className="user-list">
                           {sampleUsers.filter(user => parseInt(user.followers.replace(/[^\d]/g, '')) > 1000000).map((user, idx) => (
                              <div key={idx} className="user-card">
                                 <div className="user-info">
                                    <div className="celebrity-avatar"></div>
                                    <div className="user-details">
                                       <p className="user-name">{user.name}</p>
                                       <p className="user-meta">{user.username} • {user.followers} followers</p>
                                    </div>
                                 </div>
                                 <button className={user.following ? 'following-button' : 'follow-button'}>
                                    {user.following ? 'Following' : 'Follow'}
                                 </button>
                              </div>
                           ))}
                        </div>
                     </div>
                  </div>
               ) : (
                  <div className="search-section">
                     <h3 className="section-title">
                        {filteredUsers.length} result{filteredUsers.length !== 1 ? 's' : ''} for "{searchQuery}"
                     </h3>
                     {filteredUsers.map((user, idx) => (
                        <div key={idx} className="user-card">
                           <div className="user-info">
                              <div className={parseInt(user.followers.replace(/[^\d]/g, '')) > 1000000 ? 'celebrity-avatar' : 'user-avatar'}></div>
                              <div className="user-details">
                                 <p className="user-name">{user.name}</p>
                                 <p className="user-meta">{user.username} • {user.followers} followers</p>
                              </div>
                           </div>
                           <button className={user.following ? 'following-button' : 'follow-button'}>
                              {user.following ? 'Following' : 'Follow'}
                           </button>
                        </div>
                     ))}

                     {filteredUsers.length === 0 && (
                        <div className="no-results">
                           <p>No users found for "{searchQuery}"</p>
                           <p className="no-results-hint">Try searching for a different name or username</p>
                        </div>
                     )}
                  </div>
               )}
            </div>
         </div>
      );
   }

   return (
      <div className="home-container">
         <div className="home-header">
            <div className="welcome-section">
               <h2 className="welcome-message">{currentMessage}</h2>
               <button
                  onClick={() => setShowSearch(true)}
                  className="search-button"
               >
                  🔍
               </button>
            </div>
            <p className="welcome-subtitle">Share your style, inspire others</p>
         </div>

         <div className="posts-feed">
            {posts.map(post => (
               <div key={post.id} className="post-card">
                  <div className="post-header">
                     <div className="post-user">
                        <div className="post-avatar"></div>
                        <div className="post-user-info">
                           <p className="post-user-name">{post.user}</p>
                           <p className="post-username">{post.username}</p>
                        </div>
                     </div>
                     <span className="post-occasion">{post.occasion}</span>
                  </div>

                  <div className="post-image">
                     <Camera size={48} className="placeholder-icon" />
                  </div>

                  <div className="post-content">
                     <div className="post-actions">
                        <button className="post-action-btn">
                           <Star size={16} />
                           <span>{post.likes}</span>
                        </button>
                        {post.music && (
                           <div className="post-music">
                              <Music size={16} />
                              <span>{post.music}</span>
                           </div>
                        )}
                        {post.collaborators && (
                           <div className="post-collaborators">
                              <Users size={16} />
                              <span>{post.collaborators.join(', ')}</span>
                           </div>
                        )}
                     </div>

                     <div className="outfit-details">
                        <strong>Outfit Details:</strong>
                        {post.outfit.map((item, idx) => (
                           <div key={idx} className="outfit-item">
                              <span>{item}</span>
                              <div className="outfit-item-actions">
                                 <button
                                    className="heart-button"
                                    onClick={() => addToInterests(item)}
                                 >
                                    ♡
                                 </button>
                                 <button
                                    className="shop-link"
                                    onClick={() => setActiveTab('shop')}
                                 >
                                    Shop
                                 </button>
                              </div>
                           </div>
                        ))}
                     </div>
                  </div>
               </div>
            ))}
         </div>
      </div>
   );
};

export default Home;